import fielddata_v1 from './fielddata-v1';
import fielddata_v2 from './fielddata-v2';

export default {
  //----------------------------------
  // Globals
  //----------------------------------
  labels: {
    all: 'Alle',
    add: 'Hinzufügen',
    search: 'Suche',
    save: 'Speichern',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    review: 'Überprüfen',
    anonymize: 'Anonymisieren',
    archive: 'Archivieren',
    reopen: 'Wiedereröffnen',
    returnReview: 'Retournieren',
    transfer: 'Umteilen',
    close: 'Fertigstellen',
    lock: 'Sperren',
    unlock: 'Entsperren',
    exit: 'Schliessen',
    resolve: 'Übernehmen',
    openReadOnly: 'Im Lese-Modus öffnen',
    convert: 'Fall Konvertieren',
    changelog: {
      added: 'Neuigkeiten',
      changed: 'Änderungen',
      removed: 'Entfernungen',
      improvements: 'Verbesserungen',
      fixes: 'Korrekturen',
    },
    notnow: 'Nicht jetzt',
    participateSurvey: 'Umfrage starten',
  },
  roles: {
    office: 'Sekretariat',
    office_elevated: 'Sekretariat+',
    psychologist: 'Psycholog:in',
    spd_manager: 'SPD Manager',
    vsa_manager: 'VSA Manager',
    api_user: 'API Benutzer',
  },
  //----------------------------------
  // Sections
  //----------------------------------
  header: {
    title: 'SAV-ZH',
    navigation: {
      primary: {
        branches: 'SPD',
        inquiries: 'Fälle',
        users: 'Benutzer',
        statistics: 'Statistiken',
      },
      secondary: [
        { label: 'Support', url: '/support' },
        { icon: 'profile', url: '/user' },
      ],
    },
  },
  //----------------------------------
  // Views
  //----------------------------------
  login: {
    formlabels: {
      email: 'Benutzername (E-Mail)',
      password: 'Passwort',
      passwordrepeat: 'Passwort wiederholen',
      smscode: 'SMS-Code',
      signin: 'Anmelden',
      continue: 'Weiter',
      sendcode: 'Verifizierungscode senden',
      setpassword: 'Passwort setzen',
      forgotPassword: 'Passwort zurücksetzen?',
      support: 'Benötigen Sie Unterstützung?',
      tologin: 'Zum Login',
    },
    default: {
      headline: 'Login',
    },
    reset: {
      headline: 'Passwort zurücksetzen',
      copy: 'Bitte geben Sie uns Ihre E-Mail Adresse an. Wir werden Ihnen anschliessenden einen Verfifizierungscode an Ihre Mobile Nummer schicken.',
    },
    verify: {
      headline: 'SMS-Code eingeben',
      copy: 'Wir haben Ihnen eine SMS mit einem Code an {phone} gesendet. Geben Sie nun diesen SMS-Code ein.',
    },
    change: {
      headline: 'Neues Passwort setzen',
      copy: 'Ihr neues Passwort muss aus mindestens 8 Zeichen bestehen.',
    },
  },

  inquiries: {
    headline: 'Alle Fälle',
    copyManager: 'Hier sind alle Fälle ersichtlich die Sie erstellt haben oder in Ihrem SPD sind.',
    copyUser: 'Hier sind alle Fälle ersichtlich die Sie erstellt haben oder auf welche Sie Zugriff haben.',
    buttons: {
      newInquiry: 'Neuen Fall erfassen',
    },
    list: {
      labels: {
        firstname: 'Vorname',
        lastname: 'Nachname',
        inquiryid: 'SAV ID',
        created: 'Erstellt am',
        modified: 'Geändert am',
        psychologist: 'Fachperson',
        progress: 'Berichtsfortschritt',
        status: 'Status',
      },
      filters: {
        inquiries: {
          branch: 'SPD Fälle',
          assigned: 'Meine Fälle',
        },
        status: 'Status',
        psychologist: 'Fachperson',
      },
    },
    statuses: {
      open: 'Offen',
      progress: 'In Bearbeitung',
      progress_complete: 'In Bearbeitung',
      reviewing: 'In Überprüfung',
      reviewed: 'In Fertigstellung',
      finished: 'In Fertigstellung',
      closed: 'Abgeschlossen',
      archived: 'Archiviert',
    },
  },

  users: {
    headline: 'Alle Benutzer',
    copy: 'Hier sind alle Benutzer ersichtlich auf die Sie Zugriff haben und verwalten können.',
    buttons: {
      newUser: 'Neuen Benutzer erfassen',
    },
    list: {
      labels: {
        firstname: 'Vorname',
        lastname: 'Nachname',
        branch: 'SPD',
        role: 'Rolle',
        inquiries: 'Fälle in Bearbeitung',
        status: 'Status',
      },
      filters: {
        statuses: {
          all: 'Alle',
          active: 'Nur Aktive',
          locked: 'Nur Gesperrte',
        },
        role: 'Rolle',
        branch: 'Dienst',
      },
    },
    statuses: {
      active: 'Aktiv',
      locked: 'Gesperrt',
      deleted: 'Gelöscht',
    },
    modals: {
      edit: {
        title: 'Benutzer bearbeiten',
      },
      create: {
        title: 'Benutzer hinzufügen',
      },
    },
  },

  user: {
    locked: {
      true: 'entsperren',
      false: 'sperren',
    },
    form: {
      data: {
        success: 'Daten erfolgreich geändert',
        failed: 'Das Passwort konnte nicht aktualisiert werden. Bitte wenden Sie sich an einen Administrator.',
      },
      password: {
        success: 'Passwort erfolgreich geändert.',
        failed: 'Das Passwort konnte nicht aktualisiert werden. Bitte wenden Sie sich an einen Administrator.',
      },
    },
  },

  branches: {
    headline: 'Alle Schulpsychologischen Dienste',
    copy: 'Hier sind alle SPDs ersichtlich und können einzeln verwaltet werden.',
    buttons: {
      newBranch: 'Neuen SPD erfassen',
    },
    list: {
      labels: {
        name: 'SPD Name',
        state: 'Kanton',
        district: 'Bezirk',
        active: 'Aktive Fälle',
        completed: 'Abgeschlossene Fälle',
        archived: 'Archivierte Fälle',
        users: 'Benutzerkonten',
      },
      filters: {},
    },
    modals: {
      edit: {
        title: 'SPD bearbeiten',
      },
      create: {
        title: 'SPD hinzufügen',
      },
    },
  },

  statistics: {
    headline: 'Statistiken & Kantonale Auswertung',
    copy: 'Anonymisierte Auswertung aller vollständig ausgefüllten und archivierten SAV («Nur kantonale Daten» / for_state) über den gesamten Kanton Zürich.',
    buttons: {
      exportCsv: 'Als CSV exportieren',
    },
  },

  inquiry: {
    filters: {
      all: 'Alle EDK Daten',
      report: 'SAV ZH Bericht',
      state: 'Nur kantonale Daten',
    },
    statusExtProgressStrings: {
      open: ['Erstellen', 'Überprüfen', 'Fertigstellen', 'Archivieren'],
      progress: ['Erstellen', 'Überprüfen', 'Fertigstellen', 'Archivieren'],
      progress_complete: ['Erstellen', 'Überprüfen', 'Fertigstellen', 'Archivieren'],
      reviewing: ['Erstellt', 'Überprüfen', 'Fertigstellen', 'Archivieren'],
      reviewed: ['Erstellt', 'Überprüft', 'Fertigstellen', 'Archivieren'],
      finished: ['Erstellt', 'Überprüft', 'Fertigstellen', 'Archivieren'],
      closed: ['Erstellt', 'Überprüft', 'Fertiggestellt', 'Archivieren'],
      anonymizing: ['Erstellt', 'Überprüft', 'Fertiggestellt', 'Archivieren'],
      anonymized: ['Erstellt', 'Überprüft', 'Fertiggestellt', 'Archivieren'],
      archived: ['Erstellt', 'Überprüft', 'Fertiggestellt', 'Archiviert'],
    },
    navAction: [
      { value: 'save', label: 'Speichern' },
      { value: 'saveclose', label: 'Speichern & Schliessen' },
    ],
  },

  review: {
    filters: {
      all: 'Ganzes Formular',
      changes: 'Nur Änderungen anzeigen',
    },
    diff: {
      label: 'Neuer Wert',
      adopt: 'Übernehmen',
      ignore: 'Verwerfen',
    },
  },

  anonymize: {
    filters: {
      all: 'Alle Felder',
      unchecked: 'Noch nicht kontrollierte Felder',
    },
  },

  documents: {
    headline: 'Ressourcen & Richtlinien',
    copy: 'Zentrale Ablage für verbindliche Arbeitsmittel, Leitfäden und Dokumente. Alle relevanten Grundlagen stehen Ihnen hier zur Ansicht und zum Download bereit.',
    items: [
      {
        label: 'Kantonale Handreichung SAV ZH Bericht',
        version: '1.0',
        type: 'pdf',
        href: '/resources/Kantonale_Handreichung_SAV_ZH_Bericht_1.0.pdf',
      },
    ],
  },

  support: {
    headline: 'Hilfe & Support',
    copy: 'Hier finden sie die Antworten auf häufig gestellte Fragen.',
    items: [
      {
        question: 'Wie bereinige ich einen Datenkonflikt?',
        answer: { type: 'video', value: '1168279467?h=ee09d2c981' },
      },
      {
        question: 'Wie ändere ich mein eigenes Benutzerprofil?',
        answer: { type: 'video', value: '720557041?h=ced080fe59' },
      },
      {
        question: 'Was ist der Lebenszyklus eines Falles?',
        answer: { type: 'video', value: '728858754?h=d41c9b1d4f' },
      },
      {
        question: 'Wie erstelle ich einen neuen Fall?',
        answer: { type: 'video', value: '724476199?h=b6d9f5841a' },
      },
      {
        question: 'Wie bearbeite ich einen Fall?',
        answer: { type: 'video', value: '724415712?h=ee09d2c981' },
      },
      {
        question: 'Wie lade ich einen Bericht herunter?',
        answer: { type: 'video', value: '740287774?h=0a24a81fba' },
      },
      {
        question: 'Wie kann ich einen Fall überprüfen lassen?',
        answer: { type: 'video', value: '724512728?h=55e8be67ba' },
      },
      {
        question: 'Wie überprüfe ich einen Fall?',
        answer: { type: 'video', value: '724500096?h=4d7e248517' },
      },
      {
        question: 'Wie kann ich einen Fall fertigstellen?',
        answer: { type: 'video', value: '726700035?h=f9242ae26f' },
      },
      {
        question: 'Wie kann ich einen Fall anonymisieren und archivieren?',
        answer: { type: 'video', value: '726721146?h=7393bc665d' },
      },
      {
        question: 'Wie erfasse ich eine:n neue:n Benutzer:in?',
        answer: { type: 'video', value: '722176787?h=2e5aa60a54' },
      },
      {
        question: 'Wie bearbeite ich eine:n Benutzer:in?',
        answer: { type: 'video', value: '722190448?h=014085ac24' },
      },
      {
        question: 'Wie sperre ich eine:n Benutzer:in?',
        answer: { type: 'video', value: '722231946?h=a44026ed14' },
      },
      {
        question: 'Wie lösche ich eine:n Benutzer:in?',
        answer: { type: 'video', value: '722196696?h=76368a92ac' },
      },
      {
        question: 'Wie teile ich als SPD Manager:in einen Fall um?',
        answer: { type: 'video', value: '723055751?h=0cdf49763c' },
      },
      {
        question: 'Wie erfasse ich als VSA Manager:in einen neuen SPD?',
        answer: { type: 'video', value: '723036746?h=9a0916ad68' },
      },
      {
        question: 'Ich habe ein Problem dass hier nicht beantwortet ist. An wenn kann ich mich wenden?',
        answer: {
          type: 'text',
          value: 'Nehmen Sie direkt mit uns Kontakt auf unter folgender E-Mail Adresse: <a href="mailto:schulpsychologie@vsa.zh.ch">schulpsychologie@vsa.zh.ch</a>',
        },
      },
    ],
  },

  //----------------------------------
  // Components
  //----------------------------------

  comps: {
    diagnosis: {
      chapter: 'F-Kapitel',
      description: 'Code / Bezeichnung',
      specialist: 'Fachstelle / Jahr',
      diagnosesPrefix: 'Typ',
      tooltip: 'Grundsätzlich erfolgt die Bezeichnungen gemäss der Nomenklatur im ICD/DSM mit dem entsprechenden Code. Es dürfen keine eigenen Umschreibungen, Ergänzungen oder Bezeichnungen, die nicht im ICD/DSM erscheinen, erfolgen (gehört unter Bemerkungen). Umschreibungen von Diagnosen aus anderen Berichten (z.B. Logopädie) können nach eigener Beurteilung einer ICD/DSM-Diagnose zugeteilt und so benannt bzw. ‚übersetzt‘ werden (evt. nach Rücksprache mit der jeweiligen Fachperson).',
    },
  },

  //----------------------------------
  // Field Data
  //----------------------------------
  req: {
    f: { v: '9490f6ea-220b-4d71-86b5-b6129887d008', r: true }, /* Firstname */
    l: { v: '973834ac-3158-46be-8285-820d6545ac99', r: true }, /* Lastname */
    b: { v: 'bfdcfc5b-6f71-4987-8d5a-834e12b2dc98', r: true }, /* Branch */
    p: { v: '9c9afd9b-7a31-4c81-a236-aac8f1d543dc', r: true }, /* Psychologist */
    d: { v: 'bad095ff-8f27-4e42-9041-b4f2d9474f9e' }, /* Birthdate */
    g: { v: '510550f2-e07d-4866-bb4d-511c4563e023' }, /* Gender */
  },
  fielddata_versions: {
    1: [...fielddata_v1],
    2: [...fielddata_v2],
  },

  //----------------------------------
  // Error Handling
  //----------------------------------
  errors: {
    authentication: {
      failed: 'Login fehlgeschlagen.<br/>E-Mail oder Passwort fehlerhaft.',
    },
    verification: {
      failed: 'Ihr Zugriff konnte nicht verifiziert werden.<br/>Bitte melden Sie sich erneut an.',
    },
    branch: {
      read: {
        unauthorized: 'Sie sind nicht autorisiert, Dienste abzurufen.',
      },
      edit: {
        unauthorized: 'Sie sind nicht autorisiert, Dienste zu editieren.',
      },
      notfound: 'Der gewünschte Dienst konnte nicht gefunden werden.',
    },
    inquiry: {
      read: {
        unauthorized: 'Sie sind nicht autorisiert, diesen Fall zu öffnen.',
      },
      edit: {
        unauthorized: 'Sie sind nicht autorisiert, Fälle zu editieren.',
      },
      transfer: {
        unauthorized: 'Sie sind nicht autorisiert, Fälle umzuteilen',
      },
    },
    user: {
      create: {
        unauthorized: {
          role: 'Sie sind nicht autorisiert, diese Benutzer-Rolle zu vergeben.',
        },
      },
      read: {
        unauthorized: 'Sie sind nicht autorisiert, diesen Benutzer abzurufen.',
      },
      edit: {
        unauthorized: {
          default: 'Sie sind nicht autorisiert, diesen Benutzer zu editieren.',
          role: 'Sie sind nicht autorisiert, die Benutzer-Rolle zu editieren.',
        },
        email: {
          exists: 'Diese E-Mail Adresse wurde bereits verwendet.',
        },
      },
      update: {
      },
      notfound: 'Der gewünschte Benutzer konnte nicht gefunden werden.',
    },
  },
};
